import {Style, Fill, Stroke, Text} from 'ol/style.js';
import {transformExtent} from 'ol/proj';
import {GeoJsonLayer} from '../GeoJsonLayer.js';
import Library from '../Library.js';

export class TcfLayer extends GeoJsonLayer {

    constructor( map, settings = {}){
        settings["name"] = 'tcf';
        settings["dynamic_time"] = true;
        settings["api_endpt"] = "TcfJSON.php";
        super( map, settings );
    }

    getUrl( extent, resolution, projection ){
        let extent1 = transformExtent(extent, projection, "EPSG:4326");
        let url = new URL( this.api_path + "/" + this.api_endpt );
        url.searchParams.set( "bbox", extent1.join(","));
        url.searchParams.set( "zoom", this.map.view.getZoom());
        url.searchParams.set( "date", Library.formatDate( "ymd_hn", this.map.secs ));
        return url.toString();
    }

    getColor( feature ){
        if( this.property(feature,'type') == 'Out of season' )
            return '#000000';
        if( this.property(feature,'type') == 'Line' )
            return '#AA00AA';
        if( this.property(feature,'confidence') == 'Low' )
            return '#404040';
        return '#0040AA';
    }

    getHighlightColor( feature ){
        if( this.property(feature,'type') == 'Out of season' )
            return '#000000';
        if( this.property(feature,'type') == 'Line' )
            return '#FF55FF';
        if( this.property(feature,'confidence') == 'Low' )
            return '#AAAAAA';
        return '#0088FF';
    }

    getLabel( feature ){
        let label = "";
        if( this.property(feature,'type') == 'Out of season' )
            label = "Out of Season";
        if( this.property(feature,'coverage') == 'Sparse' )
            label = label + "S";
        else if( this.property(feature,'coverage') == 'Medium' )
            label = label + "M";
        else if( this.property(feature,'coverage') == 'Solid' )
            label = label + "H";
        else if( this.property(feature,'coverage') == 'High' )
            label = label + "H";
        if( this.property(feature,'type') == 'Area' ){
            label = label + "/";
            if( this.property(feature,'tops') == "FL>400" )
                label = label + ">400";
            else
                label = label + this.property(feature,'tops').substr(8,3);
        }
        return label;
    }

    getOpacity(feature){
        if( this.property(feature,'coverage') == 'Sparse' )
            return 0.2;
        if( this.property(feature,'coverage') == 'Medium' )
            return 0.5;
        return 0.8;
    }

    getZindex(feature){
        if( this.property(feature,'coverage') == 'Sparse' )
            return 16;
        if( this.property(feature,'coverage') == 'Medium' )
            return 18;
        return 20;
    }

    getStyle(feature, resolution){
        let style = new Style({
                "fill": new Fill({
                        "color": Library.parseHexColorToArray(this.getColor(feature), 
                                this.getOpacity(feature))
                        }),
                "stroke": new Stroke({
                        "color": Library.parseHexColorToArray(this.getColor(feature), 0.5),
                        "width": 2
                        }),
                "text": new Text({
                        "font": "12px",
                        "fill": new Fill({
                                "color": Library.parseHexColorToArray(this.getColor(feature))
                                }),
                        "text": this.getLabel(feature),
                        "stroke": new Stroke({"color": "white", "width": 2 })
                        })

                });
        return style;
    }

    getPopupText( feature ){
        let text = "";
        if( this.property(feature,'type') == "Out of season" )
            text += this.popupTitle( "TCF", "Out of season" );
        else if( this.property(feature,'type') == "Area" )
            text += this.popupTitle( "TCF", "Area" );
        else
            text += this.popupTitle( "TCF", "Line" );
        text += this.popupData( "Init Date", this.property(feature,'initTime'));
        text += this.popupData( "Forecast", this.property(feature,'fore'));
        if( this.property(feature,'type') == "Out of season" )
            text += this.popupData( "TCF is out of season from the start of November to the end of February. Please check back at the start of March" );
        else
            text += this.popupData( "Coverage", this.property(feature,'coverage') );
        if( this.property(feature,'type') == "Area" ){
            text += this.popupData( "Confidence", this.property(feature,'confidence') );
            text += this.popupData( "Growth", this.property(feature,'growth') );
            text += this.popupData( "Tops",  this.property(feature,'tops') );
            text += this.popupData( "Movement", this.property(feature,'movement') );;
        }
        text += this.popupEnd();
        return text;
    }

    updateTime(){
        this.refresh();
    }
}
